// HH:MM:SS live countdown to an RFC3339 expiry, shared by the agentic card
// and the knoc-card status popup so both tick in the same format.
export function formatCountdown(expiresAt: string, nowMs: number, expiredLabel: string): string {
  const expiryMs = new Date(expiresAt).getTime();
  // An unparseable expiry yields NaN; treat it as expired rather than rendering "NaN:NaN:NaN".
  if (Number.isNaN(expiryMs)) return expiredLabel;
  const diff = Math.max(0, Math.floor((expiryMs - nowMs) / 1000));
  if (diff <= 0) return expiredLabel;
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(Math.floor(diff / 3600))}:${pad(Math.floor((diff % 3600) / 60))}:${pad(diff % 60)}`;
}
